module.exports = __webpack_public_path__ + "public/img/head-left.8af1a76f.png";